import { render, staticRenderFns } from "./left.vue?vue&type=template&id=540acde4&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"
import style0 from "./left.vue?vue&type=style&index=0&id=540acde4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540acde4",
  null
  
)

export default component.exports